import { Route, Redirect } from 'react-router-dom';
import auth from '../../services/authentication';

interface PrivateRouteProps{
  path: string,
  exact: boolean,
  children?: Element[]
}

const PrivateRoute = ({ path, exact, children }:PrivateRouteProps) => {
  return (
    <Route path={path} exact={exact}>
      {auth.isAuthenticated()
        ? children
        : <Redirect to="/" />}
    </Route>
  );
}

export default PrivateRoute;